import { ICrossLinks } from '../../../ListingMobile/types/crossLinks';

export function crossLinksReducer(state: ICrossLinks[] | null = null): ICrossLinks[] | null {
  return state;
}
